import moment from "moment";

function normalizeTimestamp(timestamp) {
    return timestamp * 31 < Date.now()
        ? timestamp * 1000
        : timestamp;
}

function extract(seconds, from, size = null) {
    return size === null
        ? ((seconds - seconds % from) / from)
        : ((seconds - seconds % from) / from) % size;
}

function prependDigit(digit) {
    return (digit < 10 ? '0' : '') + digit.toString();
}

export function FormatDate(timestamp) {
    return new Date(normalizeTimestamp(timestamp)).toLocaleDateString('tr-TR');
}

export function FormatTime(timestamp) {
    return new Date(normalizeTimestamp(timestamp)).toLocaleTimeString('tr-TR');
}

/**
 * dd.mm.YYYY HH:ii:ss
 */
export function FormatDateTime(timestamp) {
    return new Date(normalizeTimestamp(timestamp)).toLocaleString('tr-TR');
}

/**
 * dd.mm. HH:ii
 */
export function FormatDateTimeShorter(timestamp) {
    return moment(normalizeTimestamp(timestamp)).format('DD.MM. HH:mm');
}

export function ParseDateTime(timeString) {
    const splitString = timeString.replace(/[ :]/g, '.').split('.');
    const [ dd, mm, yyyy, hh, ii, ss ] = splitString;
    const now = new Date();
    const date = new Date(
        yyyy ?? now.getFullYear(),
        mm ? mm - 1 : now.getMonth(),
        dd ?? now.getDate(),
        hh ?? now.getHours(),
        ii ?? now.getMinutes(),
        ss ?? now.getSeconds(),
    );
    return Math.round(date.getTime() / 1000);
}

export function DurationHHMMSS(totalSeconds) {
    if (totalSeconds < 0) {
        return '-' + DurationHHMMSS(-totalSeconds);
    }
    const hours = extract(totalSeconds, 3600),
        minutes = extract(totalSeconds, 60, 60),
        seconds = extract(totalSeconds, 1, 60);

    return `${prependDigit(hours)}:${prependDigit(minutes)}:${prependDigit(seconds)}`;
}